window.templating = window.templating || {};
templating.loaders = {};
templating.isCached = true;
templating.getCompiledScriptLocation = function(name) {
  return templating.dustLocations[name];
};
